export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-border/40 bg-background">
      <div className="container mx-auto max-w-screen-2xl px-4 py-1">
        <div className="mt-0 border-t border-border/40 pt-0 text-center">
          <p className="text-xs text-muted-foreground">
            © {currentYear}{' '}
            <a
              href="https://beredskapshubben.se/about"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
            >
              Beredskapshubben Norden AB
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
